import './src/theme/destyle.css'
import './src/theme/global.css'

import { ThemeProvider } from './src/theme'

export const wrapPageElement = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>
}
